/* eslint-disable react-hooks/exhaustive-deps */
import { ApButtonSecondary } from '@alixpartners/ui-components';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	GridContainer,
	GridItem,
	Header,
	HeaderSpan,
	RefreshSpan,
	TableFilterHeader,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	PREWORKSHOP_BASELINE_KPI_DATA,
	GL_HEADER,
	GL_REFRESH_HEADER,
	extractSelectedArrays,
	combinePreWorkshopBaselineKpiData,
	PREWORKSHOP_PRELIMINARY_SAVINGS_KPI_DATA,
	combinePreWorkshopData,
	PREWORKSHOP_VENDOR_KPI_DATA,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import {
	getPreWorkshopBaselineSummaryKpis,
	getPreWorkshopPreliminarySavingsSummary,
} from 'utils/apiRequests';

const healthBars = [
	'Pre-Workshop Baseline Spend Summary',
	'Identified Vendor Actions',
	'Preliminary Savings Summary',
];
function PreWorkshopTemplate() {
	const [preWorkShopBaselineKpiData, setPreWorkShopBaselineKpiData] = useState(
		PREWORKSHOP_BASELINE_KPI_DATA
	);
	const [preWorkShopVendorKpiData, setPreWorkShopVendorKpiData] = useState(
		PREWORKSHOP_VENDOR_KPI_DATA
	);
	const [reFresh, setrefresh] = useState(false);
	const [gridApi, setGridApi] = useState(null);

	const [
		preWorkShopPreliminaryKpiData,
		setPreWorkShopPreliminaryKpiData,
	] = useState(PREWORKSHOP_PRELIMINARY_SAVINGS_KPI_DATA);
	const [isLoading, setIsLoading] = useState(false);
	const selectedSpendType = ['MACRO'];
	const [selectedKPI, setSelectedKPI] = useState(0);
	const {
		filters,
		preWorkShopColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		uploadRefresh,
		handleSpendControllerFilters,
		setSpendType,
		setUploadRefresh,
	} = useSpendControllerFiltersContext();
	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[filters]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			uploadRefresh &&
				(() => {
					handleSpendControllerFilters();
					handleKpiData(filters);
				})();
		},
		[uploadRefresh]
	);
	useEffect(() => {
		setSpendType(selectedSpendType);
	}, []);
	const handleKpiData = async (filters, realTime = false) => {
		const tempFilters = extractSelectedArrays(filters);
		const microFilters = Object.assign({}, tempFilters);
		microFilters.tailSpendType = ['MACRO'];
		realTime && setIsLoading(true);
		const preWorkShopBaselineKpiDataResponse = await getPreWorkshopBaselineSummaryKpis(
			microFilters
		);
		const {
			total_Baseline_Spend,
			baseline_Spend_Actioned,
			percentage_Baseline_Spend_Actioned,
			unclaimed_Baseline_Spend,
			percentage_Unclaimed_Baseline_Spend,
			consolidate,
			continue_To_Use,
			eliminate,
			reduce_Demand,
			preworkshop_Responses_Received,
			preworkshop_Total_Supplier_Records,
			preworkshop_Responses_Received_Percentage,
		} = preWorkShopBaselineKpiDataResponse.data;
		const preWorkshopPreliminaryKpiResponse = await getPreWorkshopPreliminarySavingsSummary(
			microFilters
		);

		const tempPreWorkShopBaselineKpiData = combinePreWorkshopBaselineKpiData(
			{
				total_Baseline_Spend,
				baseline_Spend_Actioned,
				percentage_Baseline_Spend_Actioned,
				unclaimed_Baseline_Spend,
				percentage_Unclaimed_Baseline_Spend,
				preworkshop_Responses_Received,
				preworkshop_Total_Supplier_Records,
				preworkshop_Responses_Received_Percentage,
			},
			preWorkShopBaselineKpiData.data
		);
		setPreWorkShopBaselineKpiData({
			...preWorkShopBaselineKpiData,
			data: tempPreWorkShopBaselineKpiData,
		});
		const tempPreWorkshopVendorKpiData = combinePreWorkshopBaselineKpiData(
			{
				consolidate,
				continue_To_Use,
				eliminate,
				reduce_Demand,
			},
			preWorkShopVendorKpiData.data
		);
		setPreWorkShopVendorKpiData({
			...preWorkShopVendorKpiData,
			data: tempPreWorkshopVendorKpiData,
		});
		const newWorkShopKpiData = combinePreWorkshopData(
			preWorkshopPreliminaryKpiResponse,
			preWorkShopPreliminaryKpiData.data
		);
		setPreWorkShopPreliminaryKpiData({
			...preWorkShopPreliminaryKpiData,
			data: newWorkShopKpiData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	const handleClick = index => {
		setSelectedKPI(index);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<GridContainer>
					{healthBars.map((name, index) => (
						<GridItem
							key={index}
							selected={selectedKPI === index}
							onClick={() => handleClick(index)}
						>
							{name}
						</GridItem>
					))}
				</GridContainer>
				<ApButtonSecondary
					onClick={() => {
						setUploadRefresh(state => !state);
						setrefresh(state => !state);
					}}
					small
					style={{ margin: '1%' }}
				>
					Refresh/Save
				</ApButtonSecondary>
			</div>
			{selectedKPI === 0 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary {...preWorkShopBaselineKpiData} />
				</div>
			)}
			{selectedKPI === 1 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary {...preWorkShopVendorKpiData} />
				</div>
			)}
			{selectedKPI === 2 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary {...preWorkShopPreliminaryKpiData} />
				</div>
			)}
			<ColumnContainer>
				<Header>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableFilterHeader>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<BreakDownFilters gridApi={gridApi} />
				</TableFilterHeader>
				<TableWrapper n={7}>
					<TableView
						data={preWorkShopColumnDefs}
						columnDefs={preWorkShopColumnDefs.headers}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						selectedSpendType={selectedSpendType}
						refresh={reFresh}
						gridApi={gridApi}
						setGridApi={setGridApi}
					/>
				</TableWrapper>
			</ColumnContainer>
		</Container>
	);
}

export default PreWorkshopTemplate;
